
export const fieldsInfo: any = {
  // fields with half cell size
  halfSizeFields: [
    'company_name',
    'url',
    'address_1',
    'address_2',
    'email',
    'phone',
    'technical_contact_name',
    'technical_contact_email',
    'facebook',
    'linkedin',
    'twitter',
    'instagram',
    'youtube',
  ],

  // fields with quartered cell size
  quarteredSizeFields: [
    'city',
    'state',
    'zip',
    'country',
  ],

  // fields with full cell size
  fullSizeFields: [
    'general_description',
  ],

  // input fields
  inputFields: [
    'company_name',
    'url',
    'address_1',
    'address_2',
    'city',
    'zip',
    'email',
    'phone',
    'state',
    'technical_contact_name',
    'technical_contact_email',
    'facebook',
    'linkedin',
    'twitter',
    'instagram',
    'youtube',
  ],

  // select fields
  selectFields: [
    'country',
  ],

  // text fields
  textFields: [
    'description',
  ],

  // text fields
  blockFields: [
    'company_name',
    'url',
    'address_1',
    'address_2',
    'country',
    'facebook',
    'linkedin',
    'twitter',
    'instagram',
    'youtube',
    'description',
  ],
};
